import { Dispatch } from 'vuex';
import firebase from 'firebase/app';
import 'firebase/auth';
import store from "@/store";
import moment from 'moment';

let timeoutId: number | null = null;

export const initActiveSessionTimer = async (activeMaxAgeSec: number, isSkipSessionTimeout?: boolean) => {
  console.log("[ACTIVE session timer] initActiveSessionTimer()");

  if (isSkipSessionTimeout || !activeMaxAgeSec) return;

  const firebaseUser = firebase.auth().currentUser;
  if (!firebaseUser || firebaseUser.isAnonymous) return;

  const idTokenResult = await firebaseUser.getIdTokenResult(true);
  const authTime = idTokenResult?.claims?.auth_time;

  if (!authTime) {
    console.warn("[ACTIVE session timer] Missing auth_time claim.");
    return;
  }

  const authTimestamp = authTime * 1000;
  console.log(`[ACTIVE session timer] auth_time: ${moment(authTimestamp).toDate().toLocaleString()}`);

  const expiration = authTimestamp + activeMaxAgeSec * 1000;
  const delay = expiration - Date.now();

  if (delay > 0) {
    console.log(`[ACTIVE session timer] WILL TRIGGER SESSION TIMEOUT in ${Math.round(delay / 1000)} sec (at ${new Date(expiration).toLocaleString()})`);
    timeoutId = window.setTimeout(() => {
      console.log('SESSION HAS EXPIRED DUE TO MAX ACTIVE TIMEOUT', new Date().toLocaleString());
      store.dispatch('openSessionTimeout', false);
      store.dispatch("userSignOutBySessionExpired");
    }, delay);
  } else {
    console.log("[ACTIVE session timer] Session already expired.");
    store.dispatch('openSessionTimeout', false);
    store.dispatch("userSignOutBySessionExpired");
  }
};

export const stopActiveSessionTimer = () => {
  if (timeoutId !== null) {
    clearTimeout(timeoutId);
    timeoutId = null;
    console.log("[ACTIVE session timer] stopped");
  }
};
